import { render } from "./wareinforMation.vue?vue&type=template&id=f9f36140&scoped=true"
import script from "./wareinforMation.vue?vue&type=script&lang=js"
export * from "./wareinforMation.vue?vue&type=script&lang=js"

import "./wareinforMation.vue?vue&type=style&index=0&id=f9f36140&lang=scss&scoped=true"

import exportComponent from "E:\\vue-cli-pc\\测试环境\\exp2c.com\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9f36140"]])

export default __exports__